
export default function Pricing() {
  const plans = [
    {
      name: '診断',
      price: '¥50,000',
      suffix: '',
      features: [
        '現状業務の可視化',
        '工数マップ作成',
        '自動化ロードマップ提案',
        '費用対効果試算'
      ]
    },
    {
      name: '構築',
      price: '¥500,000',
      suffix: '〜',
      features: [
        'スプレッドシート設計',
        '利益計算ロジック実装',
        '出品CSV生成自動化',
        '在庫同期システム構築'
      ],
      highlight: true
    },
    {
      name: '運用顧問',
      price: '¥50,000',
      suffix: '〜/月',
      features: [
        '継続的な改善提案',
        '追加自動化の実装',
        '数値レビュー',
        '運用サポート'
      ]
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-16 md:py-24 bg-gradient-to-b from-primary/10 to-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900">
            料金<strong className="text-primary">プラン</strong>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 mb-8 md:mb-12">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-5 md:p-8 ${
                plan.highlight
                  ? 'shadow-2xl md:scale-105 border-2 border-primary'
                  : 'shadow-lg'
              } hover:shadow-xl transition-all`}
            >
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                {plan.name}
              </h3>
              
              <div className="mb-4 md:mb-6">
                <span className="text-3xl md:text-5xl font-black text-primary">{plan.price}</span>
                <span className="text-sm md:text-lg text-gray-600 ml-1">{plan.suffix}</span>
              </div>
              
              <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2 md:gap-3">
                    <i className="ri-check-line text-primary text-lg md:text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-xs md:text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <button
                onClick={scrollToContact}
                className={`w-full py-2.5 md:py-3 rounded-lg font-bold text-sm md:text-base transition-colors whitespace-nowrap cursor-pointer ${
                  plan.highlight
                    ? 'bg-primary text-white hover:bg-primary-dark'
                    : 'bg-white text-primary border-2 border-primary hover:bg-primary/5'
                }`}
              >
                詳しく見る
              </button>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <p className="text-xs md:text-sm text-gray-600">
            ※お客様の状況により見積内容が変動します。まずはご相談ください。
          </p>
        </div>
      </div>
    </section>
  );
}
